// Layout desenhado em tela de 2560px; telas menores recebem zoom proporcional ate o piso de legibilidade
export const LARGURA_REFERENCIA_LAYOUT = 2560;
export const ESCALA_MINIMA_LAYOUT = 0.7;

export const fatorEscalaLayout = (largura: number): number =>
  Math.min(1, Math.max(ESCALA_MINIMA_LAYOUT, largura / LARGURA_REFERENCIA_LAYOUT));

// CSS nao divide 100vw por px para gerar um numero, entao o fator do zoom vem daqui
export const aplicarEscalaLayout = (): (() => void) => {
  const aplicar = () =>
    document.documentElement.style.setProperty("--escala-layout", String(fatorEscalaLayout(window.innerWidth)));
  aplicar();
  window.addEventListener("resize", aplicar);
  return () => window.removeEventListener("resize", aplicar);
};
